import {
  LayoutModalAmbassador,
  LayoutModalPeopleWelcome,
  LayoutModalFaceRecMarketingUpsell,
  LayoutModalDigitizationUpsell,
  LayoutModalStorageUpsell,
  LayoutModalVideoUpsell,
  LayoutModalMoreWaysToUpload,
  LayoutModalDeclutterWelcome,
  LayoutModalVideoMergeWelcome,
  LayoutModalVideoEditWelcome,
  LayoutModalVideoTitleFrameWelcome,
  LayoutModalClubUpsell,
  LayoutModalPhotoRestorationUpsell,
  LayoutModalGenealogyUpsell,
  UserAccountAuthModal,
} from '#components';

function openAmbassadorModal() {
  useFModal({
    id: 'ambassador',
    size: 'md',
    component: LayoutModalAmbassador
  }).open();
}

function openPeopleWelcomeModal() {
  useFModal({
    id: 'people-welcome',
    size: 'lg',
    clickToClose: false,
    escToClose: false,
    component: LayoutModalPeopleWelcome
  }).open();
}

function openDeclutterWelcomeModal() {
  return new Promise(resolve => {
    let continued = false;
    const modal = useFModal({
      id: 'declutter-welcome',
      size: 'lg',
      clickToClose: false,
      escToClose: false,
      component: LayoutModalDeclutterWelcome,
      eventHandlers: {
        async continue() {
          if (continued) return;

          continued = true;
          await modal.close();
          resolve(true);
        }
      },
      onClose() {
        if (!continued) resolve(false);
      }
    });

    modal.open();
  });
}

function openVideoMergeWelcomeModal({files, contextType, contextId}) {
  return new Promise(resolve => {
    const modal = useFModal({
      id: 'video-merge-welcome',
      size: 'lg',
      clickToClose: false,
      escToClose: false,
      showClose: false,
      component: LayoutModalVideoMergeWelcome,
      eventHandlers: {
        async continue() {
          modal.close();
          const result = await useVideoEditorActions().mergeVideos({
            files,
            contextType,
            contextId
          });
          resolve(result);
        }
      }
    });

    modal.open();
  });
}

function openVideoEditWelcomeModal() {
  return new Promise(resolve => {
    const modal = useFModal({
      id: 'video-edit-welcome',
      size: 'lg',
      clickToClose: false,
      escToClose: false,
      showClose: false,
      component: LayoutModalVideoEditWelcome,
      eventHandlers: {
        continue() {
          modal.close();
          resolve(true);
        }
      }
    });

    modal.open();
  });
}

function openVideoTitleFrameWelcomeModal() {
  return new Promise(resolve => {
    const modal = useFModal({
      id: 'video-title-frame-welcome',
      size: 'lg',
      clickToClose: false,
      escToClose: false,
      showClose: false,
      component: LayoutModalVideoTitleFrameWelcome,
      eventHandlers: {
        continue() {
          modal.close();
          resolve(true);
        }
      }
    });

    modal.open();
  });
}

function openFaceRecUpsellModal({context} = {}) {
  useMarketingModal({
    id: 'facerec',
    component: LayoutModalFaceRecMarketingUpsell,
    tracking: {
      type: UPSELL_TYPES.facialRecognition,
      context
    }
  }).open();
}

function openDigitizationUpsellModal({context} = {}) {
  useMarketingModal({
    id: 'digitization-upsell',
    size: 'lg',
    component: LayoutModalDigitizationUpsell,
    tracking: {
      type: UPSELL_TYPES.digitization,
      context
    }
  }).open();
}

function openStorageUpsellModal({context} = {}) {
  useMarketingModal({
    id: 'storage-upsell',
    size: 'lg',
    component: LayoutModalStorageUpsell,
    tracking: {
      type: UPSELL_TYPES.storage,
      context
    }
  }).open();
}

function openClubUpsellModal({context} = {}) {
  useMarketingModal({
    id: 'club-upsell',
    size: 'lg',
    component: LayoutModalClubUpsell,
    tracking: {
      type: UPSELL_TYPES.club,
      context
    }
  }).open();
}

function openPhotoRestorationUpsellModal({context} = {}) {
  useMarketingModal({
    id: 'photo-restoration-upsell',
    size: 'lg',
    component: LayoutModalPhotoRestorationUpsell,
    tracking: {
      type: UPSELL_TYPES.photoRestoration,
      context
    }
  }).open();
}

function openGenealogyUpsellModal({context} = {}) {
  useMarketingModal({
    id: 'genealogy-upsell',
    size: 'lg',
    component: LayoutModalGenealogyUpsell,
    tracking: {
      type: UPSELL_TYPES.genealogy,
      context
    }
  }).open();
}

function openVideoUpsellModal({context, title, subtitle} = {}) {
  useMarketingModal({
    id: 'video-upsell',
    component: LayoutModalVideoUpsell,
    tracking: {
      type: UPSELL_TYPES.video,
      context
    },
    props: {
      title,
      subtitle
    }
  }).open();
}

function openMoreWaysToUploadModal() {
  useFModal({
    id: 'more-ways-to-upload',
    size: 'xl',
    showClose: false,
    component: LayoutModalMoreWaysToUpload
  }).open();
}

function openSignupFromShareModal({id = 'signup-from-share', referrer, referralToken, referralContext = 'share', referralSource, sendConnectionRequest, escToClose = true, onClose}) {
  return new Promise(resolve => {
    const modal = useFModal({
      id,
      component: UserAccountAuthModal,
      backdropClass: BACKDROP_BLUR_CLASS,
      clickToClose: false,
      escToClose,
      size: 'md',
      props: {
        referrer,
        referralToken,
        referralContext,
        referralSource,
        sendConnectionRequest
      },
      onClose() {
        onClose?.();
        resolve();
      },
      eventHandlers: {
       /* onComplete() {
          resolve();
          modal.close();
        }*/
      }
    });

    modal.open();
  });
}


export function useCommonModals() {
  return {
    openAmbassadorModal,
    // openHelpModal,
    openFaceRecUpsellModal,
    openPeopleWelcomeModal,
    openDeclutterWelcomeModal,
    openVideoMergeWelcomeModal,
    openVideoEditWelcomeModal,
    openVideoTitleFrameWelcomeModal,
    openDigitizationUpsellModal,
    openStorageUpsellModal,
    openClubUpsellModal,
    openPhotoRestorationUpsellModal,
    openGenealogyUpsellModal,
    openVideoUpsellModal,
    openMoreWaysToUploadModal,
    openSignupFromShareModal
  };
}
